module.exports = __webpack_public_path__ + "assets/images/payspace-not-found-mobile@2x.033ff8883c7c9b63e1b5196b0897107f.webp";